var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageRythmLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F9F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5H18",
    stroke: "#680DDB",
    strokeWidth: 3,
    strokeDasharray: "6 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageRythmLegend);
export default __webpack_public_path__ + "static/media/average-rythm-legend.028f227205a2b1f3f41cac8c688f2634.svg";
export { ForwardRef as ReactComponent };